import { fetchSubscribers } from "./actions/fetchAction";
import { SubscribersReducer } from "./reducers/fetchReducers"; 

const SubscriberReducers = {
  subscribersGlobalStore: SubscribersReducer
}

export {fetchSubscribers, SubscriberReducers};
